import AtRecommendedActionCellRenderer from '@components/agile/agileComponents/AtAcrossZoneOperation/AtAcrossZoneComponents/AtAcrossZoneDiffTableComponent/AtRecommendedActionCellRenderer';
import ImageCellRenderer from '@components/agile/agileComponents/agGridCommonComponents/ImageCellRenderer';
import { CapacityTuple } from '@components/agile/types/AgileUploadRow';
import BuyableCellRenderer from '@components/agile/agileComponents/AtAddNewAsin/AtAddTableGridComponent/BuyableCellRenderer';
import ProcurableCellRenderer from '@components/agile/agileComponents/AtAddNewAsin/AtAddTableGridComponent/ProcurableCellRenderer';
import TemperatureRatingCellRenderer from '@components/agile/agileComponents/AtAddNewAsin/AtAddTableGridComponent/TemperatureRatingCellRenderer';

const nonActionableColDefs = [
  {
    headerName: 'Recommendation',
    field: 'action',
    flex: 2,
    maxWidth: 180,
    filter: true,
    cellRenderer: AtRecommendedActionCellRenderer,
    sortable: false,
    pinned: true,
  },
  {
    headerName: 'ASIN',
    field: 'asin',
    flex: 2,
    minWidth: 120,
    maxWidth: 150,
    filter: true,
    pinned: true,
  },
  {
    headerName: 'Title',
    field: 'title',
    filter: true,
    pinned: true,
  },

  {
    field: 'image',
    cellRenderer: ImageCellRenderer,
    sortable: false,
    pinned: true,
    maxWidth: 100,
  },
  {
    headerName: 'Facings',
    field: 'facingUnits',
    flex: 2,
    minWidth: 180,
    maxWidth: 180,
  },
  {
    headerName: 'Total FOH Capacity (Units)',
    field: 'fohCapacity.capacity',
    flex: 2,
    wrapHeaderText: true,
    minWidth: 130,
    maxWidth: 165,
    headerClass: 'text-center',
    comparator: (a: CapacityTuple, b: CapacityTuple) => Number(a.capacity) - Number(b.capacity),
  },
  {
    headerName: 'Zone',
    field: 'zoneName',
    flex: 2,
    minWidth: 180,
    maxWidth: 180,
  },
  {
    headerName: 'SubCategory',
    field: 'singleCategoryName',
    editable: false,
    flex: 2,
    minWidth: 170,
    maxWidth: 170,
  },
  {
    headerName: 'Buyable',
    field: 'buyable',
    cellRenderer: BuyableCellRenderer,
  },
  {
    headerName: 'Procurable',
    field: 'procurable',
    cellRenderer: ProcurableCellRenderer,
  },
  {
    headerName: 'Temp Zone',
    field: 'temperatureRating',
    cellRenderer: TemperatureRatingCellRenderer,
  },
  {
    headerName: 'Shrink Cost (-1W)',
    field: 'shrinkCost',
    filter: true,
  },
  {
    headerName: 'Shrink % Ops (-1W)',
    field: 'shrinkPerOps',
    filter: true,
  },
  {
    headerName: 'Moving Avg Sales (-13W)',
    field: 'movingAvgSales13week',
    filter: true,
    flex: 2,
  },
  {
    headerName: 'UPHL1',
    field: 'uphl1',
    filter: true,
  },
  {
    headerName: 'UPHL2',
    field: 'uphl2',
    filter: true,
  },
  {
    headerName: 'UPHL3',
    field: 'uphl3',
    filter: true,
  },
];

export default nonActionableColDefs;
